<div class="module-banner-main">
    <div class="content">
        <div class="content-form">
            <produto-search-banner></produto-search-banner>
        </div>
        <div class="content">
            <figure *ngIf="width >= 767">
                <img src="/images/modulo/banner/{{data.imagem}}" alt="Serra Gaúcha" width="100%" height="auto" />
            </figure>
            <figure *ngIf="width < 767">
                <img src="/images/modulo/banner/mobile/{{data.imagem_mobile}}" alt="Serra Gaúcha" width="100%" height="auto" />
            </figure>
        </div>
    </div>
</div>